import { ICompanyLogo } from '@my-backoffice/app/pages/main/shared/components/header/shared/interfaces/companyLogo.interface';
import { IUser } from '@my-backoffice/app/pages/user/shared/models/interfaces/user.interface';
import { AUTHENTICATION_SERVICE } from '@my-backoffice/app/shared/auth/authentication.token';
import { SERVER_URL } from '@my-backoffice/app/shared/constants/app.constants';
import { LANGUAGES } from '@my-backoffice/app/shared/constants/languages.constants';
import { ELocalForageKeys } from '@my-backoffice/app/shared/models/enums/localforage-keys.enum';
import { EStorageKeys } from '@my-backoffice/app/shared/models/enums/storage-keys.enum';
import { ESupportedLanguage } from '@my-backoffice/app/shared/models/enums/supported-language.enum';
import { QimaNullableType } from '@my-backoffice/app/shared/models/types/qima.type';
import { AppBrowserDetectService } from '@my-backoffice/app/shared/services/browser-services/app-browser-detect/app-browser-detect.service';
import { HttpService } from '@my-backoffice/app/shared/services/http-services/http.service';
import { StorageService } from '@my-backoffice/app/shared/services/storage-services/storage.service';
import { HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import localforage from 'localforage';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  public readonly isProfileMenuVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isTranslateMenuVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public activeLanguageIndex$: Subject<number> = new Subject<number>();
  public readonly companyLogo$: Subject<string> = new Subject<string>();

  private readonly _authenticationService = inject(AUTHENTICATION_SERVICE);

  public constructor(
    private readonly _appBrowserDetectService: AppBrowserDetectService,
    private readonly _storageService: StorageService,
    private readonly _httpService: HttpService
  ) {
    void localforage.getItem(ELocalForageKeys.LOCALE_LANGUAGE).then((data): void => {
      const language = data || this._appBrowserDetectService.getSupportedBrowserLanguage() || ESupportedLanguage.ENGLISH;

      this.activeLanguageIndex$.next(LANGUAGES.findIndex((item): boolean => item.value === language));
    });
  }

  public getCompanyLogo$(): Observable<QimaNullableType<string>> {
    const userId = this._storageService.getItem(EStorageKeys.USER_ID);
    const user: IUser = this._authenticationService.getCurrentUser();

    if (!user?.company?.id) {
      return of(null);
    }

    return this._httpService.httpClient
      .get<ICompanyLogo>(`${SERVER_URL}/user/${userId}/company/${user.company.id}/logo`, { observe: 'response' })
      .pipe(map((response: Readonly<HttpResponse<ICompanyLogo>>): QimaNullableType<string> => response?.body?.image || null));
  }

  public updateIsProfileMenuVisible(isProfileMenuVisible: boolean): void {
    this.isProfileMenuVisible$.next(isProfileMenuVisible);
  }

  public updateIsTranslateMenuVisible(isTranslateMenuVisible: boolean): void {
    this.isTranslateMenuVisible$.next(isTranslateMenuVisible);
  }

  public updateActiveLanguageIndex(index: number): void {
    this.activeLanguageIndex$.next(index);
  }

  public updateCompanyLogo(logo: string): void {
    this.companyLogo$.next(logo);
  }
}
